module.exports = __webpack_public_path__ + "static/media/pibitoCropped.e05efd84.png";